import { render, staticRenderFns } from "./KugouMusic.vue?vue&type=template&id=424f3538&scoped=true&"
import script from "./KugouMusic.vue?vue&type=script&lang=js&"
export * from "./KugouMusic.vue?vue&type=script&lang=js&"
import style0 from "./KugouMusic.vue?vue&type=style&index=0&id=424f3538&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f3538",
  null
  
)

export default component.exports